import { PropTypes } from 'prop-types';
import React, { useState } from 'react';

import { COLORS } from '../../../constants/colors';
import { getFormattedDate } from '../../../utils';
import Link from '../../Link';
import TitleLabel from '../../Titles/TitleLabel';
import CardImageBasedXLargeControls from './CardImageBasedXLargeControls';
import CardImageBasedXLargeSwiper from './CardImageBasedXLargeSwiper';

const theme = {
  backgroundColor: COLORS.liquorice,
  color: COLORS.snow,
};

const CardImageBasedXLarge = ({ carousel }) => {
  // store swiper instance
  const [swiper, setSwiper] = useState(null);
  const [realIndex, setRealIndex] = useState(null);

  const slide = carousel[realIndex];

  const publishedDate = slide?.publishedDate ?? '';
  const title = slide?.title ?? '';
  const headline = slide?.header?.headline ?? '';

  const date = publishedDate !== '' ? getFormattedDate(publishedDate) : false;

  return (
    <div
      className="grid grid-cols-12 gap-x-3.75 sm:gap-x-5 lg:gap-x-10"
      data-component-id="card_image_link"
    >
      <div className="relative col-span-12">
        <div className="absolute bottom-0 right-0 z-10">
          <CardImageBasedXLargeControls
            carousel={carousel}
            realIndex={realIndex}
            swiper={swiper}
            theme={theme}
          />
        </div>

        <CardImageBasedXLargeSwiper
          carousel={carousel}
          className="h-60 sm:h-[420px] lg:h-[380px] lgH:h-[500px] image-hover"
          setRealIndex={setRealIndex}
          setSwiper={setSwiper}
        />
      </div>
      <div className="sm:col-span-9 col-span-full">
        <div className="mt-4">
          <TitleLabel franchise={slide?.franchise} tags={slide?.tags} />
        </div>
        <h1 className="mt-2 stink-h1 text-liquorice">
          <Link className="stink-h1 text-hover" to={slide?.url}>
            {title}
          </Link>
        </h1>
        <p className="mt-2 text-slate stink-body-1">{headline}</p>
        {date && <p className="mt-3 stink-footnote text-slate">{date}</p>}
      </div>
    </div>
  );
};

CardImageBasedXLarge.propTypes = {
  carousel: PropTypes.array,
};

export default CardImageBasedXLarge;
